export const MAIL_CALENDAR_CHAT_WRITEBACK_ENABLED = false
